import {isNil} from 'ramda';
import {isFalse, isTrue} from 'ramda-adjunct';

import {MinipurchaseResponseBody} from '@dms/api/finance';

import {Nullish} from 'shared/web';

import {ExternalFilter} from '../types/ExternalFilter';

// The minipurchase API returns prices as decimal strings ("100000.00") despite the number type.
const toPrice = (price: number | Nullish) => (isNil(price) ? null : Number(price));

// eslint-disable-next-line complexity -- Pre-existing violation
export const transformMinipurchaseToExternalFilter = (
  miniPurchase: MinipurchaseResponseBody | Nullish
): ExternalFilter => ({
  type: [miniPurchase?.filteredSpecifications?.type ?? 'VEHICLETYPE_PASSENGER_CAR'],
  make: miniPurchase?.filteredSpecifications?.make ?? null,
  modelFamily: miniPurchase?.filteredSpecifications?.modelFamily ?? null,
  trimLevel: miniPurchase?.filteredSpecifications?.trimLevel ?? null,
  fuelType: miniPurchase?.filteredSpecifications?.fuelType ?? null,
  transmission: miniPurchase?.filteredSpecifications?.transmission ?? null,
  bodyStyle: miniPurchase?.filteredSpecifications?.bodyStyle ?? null,
  bodyColor: miniPurchase?.filteredSpecifications?.bodyColor ?? null,
  labelIds: miniPurchase?.filteredSpecifications?.labelIds ?? null,
  salePresetId: miniPurchase?.filteredSpecifications?.salePresetId ?? null,
  drive: miniPurchase?.filteredSpecifications?.drive ?? null,
  priceFrom: toPrice(miniPurchase?.filteredSpecifications?.price?.[0]),
  priceTo: toPrice(miniPurchase?.filteredSpecifications?.price?.[1]),
  mileageFrom: miniPurchase?.filteredSpecifications?.mileage?.[0] ?? null,
  mileageTo: miniPurchase?.filteredSpecifications?.mileage?.[1] ?? null,
  powerFrom: miniPurchase?.filteredSpecifications?.power?.[0] ?? null,
  powerTo: miniPurchase?.filteredSpecifications?.power?.[1] ?? null,
  yearFrom: miniPurchase?.filteredSpecifications?.year?.[0] ?? null,
  yearTo: miniPurchase?.filteredSpecifications?.year?.[1] ?? null,
  cubicCapacityFrom: miniPurchase?.filteredSpecifications?.cubicCapacity?.[0] ?? null,
  cubicCapacityTo: miniPurchase?.filteredSpecifications?.cubicCapacity?.[1] ?? null,
  vatDeductible: isTrue(miniPurchase?.filteredSpecifications?.vatDeductible) // eslint-disable-line no-nested-ternary -- Pre-existing violation
    ? ['true']
    : isFalse(miniPurchase?.filteredSpecifications?.vatDeductible)
      ? ['false']
      : null,
  additionalInformation: miniPurchase?.additionalInformation ?? null,
  features: miniPurchase?.filteredSpecifications?.features ?? [],
  condition: miniPurchase?.filteredSpecifications?.condition ?? null,
});
